// Because is easier to read than !isUndefined(undefinedValue)
// and lodash doesn't support it yet ¯\_(ツ)_/¯

/**
 * Checks if `value` is `defined`.
 *
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `defined`, else `false`.
 * @example
 *
 * isDefined(void 0)
 * // => false
 *
 * isDefined(null)
 * // => true
 */
function isDefined(value) {
  return value !== undefined;
}

export default isDefined;
